import { ALERT } from './actionTypes';

export function exibeAlerta(config) {
    return { type: ALERT, config };
}
